import { ManualCheckIn, ManualCheckInTable } from "@/types/check-in";
import { ApiResponse } from "@/types";
import { apiSlice } from "@/redux/apiSlice";

export const CheckIn = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getManualCheckIns: builder.query<ManualCheckInTable, { query: string }>({
        query: ({ query }) => ({
          url: `/checkin/access-logs${query.length > 0 ? "?" + query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["CheckIn"],
      }),
      createManualCheckin: builder.mutation<ApiResponse, ManualCheckIn>({
        query: (data) => ({
          url: `/checkin/manual`,
          method: "POST",
          body: data,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["CheckIn"],
      }),
      createQRToken: builder.mutation<{ token: string }, { user_id: number, org_id: number, user_type: string, type: string }>({
        query: (data) => ({
          url: `/checkin/generate-token`,
          method: "POST",
          body: data,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["CheckIn"],
      }),
    };
  },
});

export const { useGetManualCheckInsQuery, useCreateManualCheckinMutation, useCreateQRTokenMutation } =
  CheckIn;
